











































import { Component, Prop, Vue } from 'vue-property-decorator';
import imageCompression from 'browser-image-compression';
import waiting from '@/components/loading/waiting';

@Component({
  directives: {
    waiting,
  },
})
export default class Input extends Vue {
    @Prop({ default: false }) uploading!: boolean
    commentString: string = '';
    submit (comment: string) {
      if (this.commentString.length) {
        this.$emit('submit', this.commentString);
        this.commentString = '';
      }
    }
    async selectImage (event: any) {
      if (!event.target.files.length) return;
      this.$emit('start-uploading');
      const imageFile = event.target.files[0];
      let options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      try {
        const compressedFile = await imageCompression(imageFile, options);
        this.$emit('attach', compressedFile, this.commentString);
        this.commentString = '';
      } catch (error) {
        console.log(error);
      }
    }
}
